import React from 'react';
import { Row, Col } from 'antd';

import { CardConsulta } from './CardConsulta';

import * as S from '../styles';

export function DadosConsultas({ data, loading = false }) {
  return (
    <Row justify="space-between">
      <Col span={24}>
        <S.SectionCard variant="outlined">
          <Col span={24} style={{ marginBottom: 26 }}>
            <Row>
              <Col flex="auto">
                <S.TitleSectionMotorista>Atendimento</S.TitleSectionMotorista>
              </Col>
            </Row>
          </Col>
          <Col span={24} style={{ paddingBottom: 32 }}>
            <Row gutter={[48, 24]}>
              {loading &&
                [0, 1]?.map((_, index) => (
                  <CardConsulta key={index} loading={loading} />
                ))}
              {data?.consultasAtendimento?.map((item, index) => (
                <CardConsulta data={item} key={index} />
              ))}
            </Row>
          </Col>
          <Col span={24}>
            <Row style={{ marginBottom: 12 }}>
              <S.ModalTitle>Observações</S.ModalTitle>
            </Row>
            <Row>
              <Col span={17}>
                {!!data && (
                  <S.TextAreaDetalhamento
                    disabled
                    autoSize={{ minRows: 5, maxRows: 5 }}
                    value={data?.motivoFinalizacao || ''}
                  />
                )}
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row style={{ marginBottom: 12, marginTop: 12 }}>
              <S.ModalTitle>Anotações internas</S.ModalTitle>
            </Row>
            <Row>
              <Col span={17}>
                {!!data && (
                  <S.TextAreaDetalhamento
                    disabled
                    autoSize={{ minRows: 5, maxRows: 5 }}
                    value={data?.observacaoInterna || ''}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </S.SectionCard>
      </Col>
    </Row>
  );
}
